const PostRichSnippets = ({
                            postUrl,
                            description,
                            createdAt,
                            updatedAt,
                            author,
                            imageUrl,
                            organizationLogoUrl,
                            organizationName
                          }: PostRichSnippetsProps) =>
  `{
    "@context": "https://schema.org",
    "@type": "TechArticle",
    "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${postUrl}"
    },
    "headline": "${description}",
    "image": [
        "${imageUrl}"
    ],
    "datePublished": "${createdAt}",
    "dateModified": "${updatedAt}",
    "author": {
        "@type": "Person",
        "name": "${author}"
    },
    "publisher": {
        "@type": "Organization",
        "name": "${organizationName}",
        "logo": {
            "@type": "ImageObject",
            "url": "${organizationLogoUrl}"
        }
    }
}`;

export interface PostRichSnippetsProps {
  postUrl: string,
  description: string,
  createdAt: string,
  updatedAt: string,
  author: string,
  imageUrl: string,
  organizationLogoUrl: string,
  organizationName: string,
}

export default PostRichSnippets;
